var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _ from 'lodash';
import { ContainerClient } from '@azure/storage-blob';
import AzureStorageEntry from '../models/AzureStorageEntry';
var VirtualPathDelimiter = '/';
var DefaultMaxPageSize = 100;
var AzureContainerService = /** @class */ (function () {
    function AzureContainerService() {
    }
    AzureContainerService.prototype.listContainer = function (containerUriWithSas, prefix, continuationToken, maxPageSize) {
        if (prefix === void 0) { prefix = undefined; }
        if (continuationToken === void 0) { continuationToken = undefined; }
        if (maxPageSize === void 0) { maxPageSize = DefaultMaxPageSize; }
        return __awaiter(this, void 0, void 0, function () {
            var result, containerClient, iterator, buildUri, entity, page, blobs, prefixes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        containerClient = new ContainerClient(containerUriWithSas);
                        iterator = containerClient
                            .listBlobsByHierarchy(VirtualPathDelimiter, {
                            prefix: prefix,
                        })
                            .byPage({
                            maxPageSize: maxPageSize,
                            continuationToken: continuationToken,
                        });
                        buildUri = function (name) {
                            var containerUriWithSasParts = containerUriWithSas.split('?');
                            return containerUriWithSasParts[0] + "/" + name + "?" + containerUriWithSasParts[1];
                        };
                        return [4 /*yield*/, iterator.next()];
                    case 1:
                        entity = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!entity.done) return [3 /*break*/, 4];
                        page = entity.value;
                        blobs = page.Blobs.Blob ? _.isArray(page.Blobs.Blob) ? page.Blobs.Blob : [page.Blobs.Blob] : [];
                        prefixes = page.Blobs.BlobPrefix ? _.isArray(page.Blobs.BlobPrefix) ? page.Blobs.BlobPrefix : [page.Blobs.BlobPrefix] : [];
                        result.push.apply(result, __spreadArray([], __read(blobs.map(function (blob) { return AzureStorageEntry.create({
                            kind: 'blob',
                            fullName: blob.Name,
                            uri: buildUri(blob.Name)
                        }); })), false));
                        result.push.apply(result, __spreadArray([], __read(prefixes.map(function (blobPrefix) { return AzureStorageEntry.create({
                            kind: 'prefix',
                            // INFO: has slash at the end 
                            fullName: blobPrefix.Name,
                            uri: buildUri(blobPrefix.Name)
                        }); })), false));
                        return [4 /*yield*/, iterator.next()];
                    case 3:
                        entity = _a.sent();
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    return AzureContainerService;
}());
export default new AzureContainerService();
//# sourceMappingURL=AzureContainerService.js.map